import { concat } from 'lodash';
import { useCallback, useState, useTransition } from 'react';
import {
  useGetLayoutScreens,
  useModal,
  useViewAssemblyComponents,
} from 'src/hooks';
import type { IAssemblyListing } from 'src/interfaces';

export const useAssemblyPreviewSidebar = (
  highlightedAssembly?: IAssemblyListing,
) => {
  const assemblyInfoModal = useModal();

  const [hasModalPreviewLoaded, setHasModalPreviewLoaded] = useState(false);

  const [isLoadingModalPreview, startTransition] = useTransition();

  const { data: layouts = [] } = useGetLayoutScreens(
    highlightedAssembly?.layout_id,
    !!highlightedAssembly?.layout_id,
  );

  const { data: [assemblyComponentsDetails] = [] } = useViewAssemblyComponents(
    [`id=${highlightedAssembly?.id}`, 'omitCovered=true'],
    !!highlightedAssembly?.id,
  );

  const assemblyComponents = concat(
    assemblyComponentsDetails?.data ?? [],
    assemblyComponentsDetails?.backupAssemblyComponents ?? [],
    assemblyComponentsDetails?.parentAssemblyComponents ?? [],
  );

  const onHandleModalOpen = useCallback(() => {
    assemblyInfoModal.onOpenModal();

    startTransition(() => {
      setHasModalPreviewLoaded(true);
    });
  }, [assemblyInfoModal]);

  const onHandleModalClose = useCallback(() => {
    assemblyInfoModal.onCloseModal();
    setHasModalPreviewLoaded(false);
  }, [assemblyInfoModal]);

  return {
    assemblyComponentsDetails,
    assemblyInfoModal,
    assemblyComponents,
    layouts,
    onHandleModalOpen,
    onHandleModalClose,
    hasModalPreviewLoaded,
    isLoadingModalPreview,
  };
};
